/**
 * Finanzielle Kennzahlen und ihre Sichtbarkeit.
 *
 * Grundgedanke: Ein Betrag ist die schuetzenswerteste Angabe eines Sponsorvertrags.
 * Wer ihn nicht sehen darf, soll den Vertrag trotzdem einordnen koennen - deshalb
 * wird statt der Zahl eine Groessenklasse ausgewiesen.
 *
 * Die Einstufung erfolgt ausschliesslich serverseitig. Der Client erhaelt bei
 * fehlender Berechtigung `amount: null` und nur die Klasse - die Zahl verlaesst
 * den Server also gar nicht erst.
 */
export const FINANCE_BANDS = ['GREEN', 'YELLOW', 'ORANGE'];
export const FINANCE_BAND_LABELS = {
    GREEN: 'Kleiner Betrag',
    YELLOW: 'Mittlerer Betrag',
    ORANGE: 'Großer Betrag',
};
/** Vorgabewerte in Cent - je Verein in den Einstellungen anpassbar. */
export const DEFAULT_FINANCE_THRESHOLDS = {
    /** Ab diesem Betrag gilt „mittel" (Vorgabe 500 €). */
    mediumCents: 50_000,
    /** Ab diesem Betrag gilt „groß" (Vorgabe 2.000 €). */
    highCents: 200_000,
};
/**
 * Ordnet einen Betrag einer Groessenklasse zu.
 * Die Grenzen sind einschliesslich: genau 500 € gilt bereits als „mittel".
 */
export function financeBand(amountCents, thresholds) {
    if (amountCents >= thresholds.highCents)
        return 'ORANGE';
    if (amountCents >= thresholds.mediumCents)
        return 'YELLOW';
    return 'GREEN';
}
/**
 * Beschriftung der Klasse inklusive Bereichsangabe, z. B. „Mittlerer Betrag
 * (500 € – 2.000 €)". Wird als Erklaerung am Abzeichen angezeigt, damit auch
 * ohne Zahl nachvollziehbar bleibt, was die Farbe bedeutet.
 */
export function financeBandRange(band, thresholds) {
    const euro = (cents) => new Intl.NumberFormat('de-AT', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
    }).format(cents / 100);
    if (band === 'GREEN')
        return `unter ${euro(thresholds.mediumCents)}`;
    if (band === 'YELLOW')
        return `${euro(thresholds.mediumCents)} – ${euro(thresholds.highCents)}`;
    return `ab ${euro(thresholds.highCents)}`;
}
//# sourceMappingURL=finance.js.map